import { CancelType } from 'types/job_schedule_worker_cancel_history'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'

const resource = 'job_schedule_worker_cancel_histories'

export const requests = {
  create: async (params: {
    job_schedule_id: number
    cancel_type: CancelType
  }) => {
    return await axiosForGigbaseBiz.post<DataResponse>(resource, params)
  },
}
